import React from 'react';
var context = /*#__PURE__*/React.createContext(null);
context.displayName = 'CardContext';
export default context;